import React from 'react';

import {Sequence} from 'components/Sequence';
import Annotation from 'molbio/annotations/backbone/Annotation';
import * as sequtil from 'molbio/SeqUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface AnnotationProps {
  annotation: Annotation;
  sequence: Sequence;
  sequtil: unknown;
}

function AnnotationRow({annotation, sequence}: AnnotationProps): JSX.Element {
  const start = annotation.start();
  const end = annotation.end();
  const length = sequtil.length(start, end, sequence.length());

  const dispStart = sequtil.modelStartToDisplay(start, sequence.startIndex());
  const dispEnd = sequtil.modelEndToDisplay(end, sequence.length(), sequence.startIndex());

  return (
    <>
      <td>
        <input
          type="checkbox"
          className="visibility-toggle"
          defaultChecked={annotation.get('visible')}
          value={annotation.cid}
        />
      </td>
      <td className="annotation-name">{annotation.name()}</td>
      <td {...getTestProps({component: 'AnnotationRow', element: 'location'})}>
        {dispStart}-{dispEnd}
      </td>
      <td>{length}</td>
      <td>
        <div style={{backgroundColor: annotation.color()}} className="swatch" />
      </td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<AnnotationProps>(AnnotationRow);
